export const baseUrl = "https://api.themoviedb.org/3/";
export const api_key = "834c193ca1db3c5318aaf7d115b90231";

export const image_baseUrl = "https://image.tmdb.org/t/p/w500";
